import { Component } from '@angular/core';

@Component({
    selector: 'leadership-section',
    standalone: true,
    imports: [],
    templateUrl: './leadership-section.component.html',
    styleUrl: './leadership-section.component.less',
})
export class LeadershipSectionComponent {}
